import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import VueAnalytics from 'vue-analytics';
//and then use it in main.js

Vue.config.productionTip = false;

new Vue({
  vuetify,
  render: h => h(App)
}).$mount('#app');
Vue.use(VueAnalytics, {
  id: 'G-N4ZB3T4TCC'
});
